<template>
  <div>
    <Autosuggest
      :model="storeNameModel"
      :suggestions="filteredOptionsStore"
      :placeholder="'tên cửa hàng'"
      :state="validateStore"
      :disabled="disable"
      :limit="10"
      @select="onSelectedStore"
      @change="onInputChangeStore"
    />
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';

export default {
  props: ['onSubmiting', 'storeId', 'storeName', 'disable'],
  data() {
    return {
      filteredOptionsStore: [],
      optionsStore: [
        {
          data: [],
        },
      ],
    };
  },
  watch: {},
  components: {
    Autosuggest,
  },
  computed: {
    validateStore() {
      return !this.storeId && this.onSubmiting ? false : true;
    },
    storeNameModel: {
      get: function () {
        return this.storeName;
      },
      set: function (newValue) {
        this.$emit('update:storeName', newValue);
      },
    },
    storeIdModel: {
      get: function () {
        return this.storeId;
      },
      set: function (newValue) {
        this.$emit('update:storeId', newValue);
      },
    },
  },
  mounted() {
    this.fetchStoreByUser();
    this.storeNameModel = this.storeName ? this.storeName : '';
  },
  methods: {
    onSelectedStore(option) {
      if (option) {
        this.storeIdModel = option.item.id;
        this.storeNameModel = option.item.name;
        this.fetchStoreByUser();
        // arg #2 = full store object (cho parent auto-fill downstream).
        // arg #3 = userInitiated=true (user-clicked) → parent có thể overwrite
        // shippingAddress kể cả khi đã có giá trị. Consumer cũ chỉ nhận arg #1
        // vẫn hoạt động.
        this.$emit('onStoreSelected', option.item.id, option.item, true);
      }
    },
    onInputChangeStore(text) {
      const filteredData = this.optionsStore[0].data
        .filter((item) => {
          return (
            item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, this.limit);
      this.filteredOptionsStore = filteredData;
    },
    fetchStoreByUser() {
      ApiService.get(`stores/get-by-user`).then(({ data }) => {
        if (data.status !== 1) return;
        const stores = data.data.stores;
        if (stores.length === 1 && !this.storeId) {
          // Single store + chưa preset → auto-pick (behavior gốc). Emit để
          // parent biết storeId vừa được auto-set. Bills consumer dùng emit này
          // để fetch list NV theo store → cần thiết.
          this.storeIdModel = stores[0].id;
          this.storeNameModel = stores[0].name;
          this.$emit('onStoreSelected', stores[0].id, stores[0]);
        } else {
          this.optionsStore[0].data = stores;
          this.filteredOptionsStore = [...this.optionsStore[0].data];
        }
        // CHỦ Ý không emit `onStoreSelected` khi parent đã preset `this.storeId`
        // (vd BillInfo load bill cũ → storeId = bill.storeId từ trước khi
        // SearchStore mount). Trước đó mình từng thêm emit-on-preset để
        // `info.vue` auto-fill shippingAddress, nhưng user feedback "vừa vào
        // đã hiện địa chỉ tôi chưa chọn" → đã sửa info.vue chỉ fill khi
        // userInitiated=true. Còn `BillInfo.onStoreSelected` luôn wipe
        // `listBillItem = []` → nếu emit-on-mount sẽ xoá sạch items vừa load
        // từ getBillById. → Revert emit-on-preset (2026-05-14).
      });
    },
  },
};
</script>
